













































import { Component, Prop, Watch } from 'vue-property-decorator';
import i18n from '@/services/i18n';
import { ComponentBase, NumberInput } from '../components';
import * as common from '../common';
import type { Report2, Utils } from '../types';
import type { Fzp } from './types';


@Component({
    components: {
        NumberInput,
    },
})
export default class FzpReportRow extends ComponentBase {
    constructor() {
        super('');
    }


    // region Модель, свойства компонента
    /**
     * Текст первой ячейки (обычно - название АБП)
     */
    @Prop({ required: true })
    public readonly firstCellText!: string;

    /**
     * Список отображаемых колонок
     */
    @Prop({ required: true })
    public readonly columns!: Array<Report2.Content.ColumnItem.Column>;

    /**
     * [Свойство компонента] Контроллер для управления содержимым отчета: определение редактируемых колонок,
     * пересчет содержимого строки и т.п.
     */
    @Prop({ required: true })
    public readonly controller!: Fzp.Controller;

    /**
     * [Свойство компонента] Строка из содержимого отчета
     */
    @Prop({ required: true })
    public readonly data!: Fzp.ReactiveReportRow;

    /**
     * [Свойство компонента] Часть отчета, к которой относится текущая строка
     */
    @Prop({ required: true })
    public readonly reportPart!: Fzp.ReactiveReportPart;

    /**
     * [Свойство компонента] Ключ строки
     */
    @Prop({ required: true })
    public readonly rowKey!: string;
    // endregion


    // region Утилиты
    private get numberFormatter(): Utils.NumberInput.Formatter {
        return common.createFormatter(i18n.locale, 0, 3);
    }
    // endregion


    get variant(): string {
        const typedData = (this.data as unknown as Fzp.ReactiveReportRow);

        if (typedData.isChanged || this.reportPart.isRejectReasonChanged(this.rowKey)) {
            return 'success';
        } else {
            return '';
        }
    }


    // region Значения ячеек
    public cellUpdateTimeoutMapByColumnKey = new Map<string, number>();

    /**
     * Карта "columnKey колонки - ячейка строки отчетаs"
     */
    public get cellMapByColumnKey(): Record<string, Fzp.ReportCell | undefined> {
        const result: Record<string, Fzp.ReportCell> = {};

        for (const cell of this.data.cells) {
            result[cell.columnKey] = cell;
        }

        return result;
    }

    /**
     * Получение значения ячейки для определенной колонки в виде числа
     *
     * @param columnKey "ключ" колонки
     */
    public getCellValue(columnKey: string): number {
        const cell = this.cellMapByColumnKey[columnKey];
        return cell?.value ?? 0;
    }

    /**
     * Получение значения ячейки для определенной колонки в виде форматированного текста
     *
     * @param columnKey "ключ" колонки
     */
    public getCellValueFormatted(columnKey: string): string {
        const value = this.getCellValue(columnKey);
        const result = this.numberFormatter(value);
        return result ?? '';
    }

    public setCellValue(columnKey: string, value: number | null | undefined) {
        const cell = this.cellMapByColumnKey[columnKey];
        if (cell === undefined) {
            return;
        }

        const oldTimeoutId = this.cellUpdateTimeoutMapByColumnKey.get(columnKey) ?? null;
        if (oldTimeoutId !== null) {
            clearTimeout(oldTimeoutId);
        }

        const newTimeoutId = setTimeout(
            () => {
                this.cellUpdateTimeoutMapByColumnKey.delete(columnKey);
                cell.value = (value ?? 0);
                this.recalculateCells();
            },
            500,
        );
        this.cellUpdateTimeoutMapByColumnKey.set(columnKey, newTimeoutId);
    }

    public recalculateCells() {
        this.controller.recalculate(this.data.cells);
    }
    // endregion
}
